import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperClass from 'swiper';
import { Controller } from 'swiper/modules';

import { styled } from '@mui/material';

import { CircleCheckmarkIcon } from '@mewa/ui';

import Image from '../../../components/image';
import { ProductFallbackImage } from '../../../components/product-fallback-image';
import { jpgPath } from '../../../helpers/asset-factory';
import { Props } from '../types';

export const ThumbSwiper = ({
  variants,
  setThumbSwiper,
  thumbCount,
  useMbsFallbackIcon,
  activeIndex,
  variantSwiper,
}: {
  variants: Props['pimProduct']['variants'];
  setThumbSwiper?: React.Dispatch<React.SetStateAction<SwiperClass | null>>;
  thumbCount: number;
  useMbsFallbackIcon: boolean;
  activeIndex: number;
  variantSwiper: SwiperClass | null;
}) => {
  return (
    <Swiper
      slidesPerView={thumbCount}
      centeredSlides={true}
      spaceBetween={36}
      slideToClickedSlide={true}
      onSwiper={setThumbSwiper}
      initialSlide={activeIndex}
      allowTouchMove={false}
      roundLengths
      modules={[Controller]}
      controller={{ control: variantSwiper }}
    >
      {variants.map((variant, index) => (
        <SwiperSlide key={variant.name}>
          <ThumbSlideContent
            key={variant.name}
            variant={variant}
            isActive={index === activeIndex}
            useMbsFallbackIcon={useMbsFallbackIcon}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const ThumbSlideContent = React.memo(
  ({
    variant,
    isActive,
    useMbsFallbackIcon,
  }: {
    variant: Props['pimProduct']['variants'][0];
    isActive: boolean;
    useMbsFallbackIcon: boolean;
  }) => {
    const imgData = slideImg(variant.assetId ?? '', 150);

    return (
      <ThumbSlideImageWrapper>
        {isActive && (
          <ActiveThumbIconWrapper>
            <CircleCheckmarkIcon color="var(--color-light-red)" />
          </ActiveThumbIconWrapper>
        )}
        {variant.assetId ? (
          <Image images={[imgData]} alt={variant.colorName ?? ''} />
        ) : (
          <DarkProductFallbackImage useMbsFallbackIcon={useMbsFallbackIcon} />
        )}
      </ThumbSlideImageWrapper>
    );
  },
);

const DarkProductFallbackImage = styled(ProductFallbackImage)({
  fill: 'var(--color-medium-grey)',
});

const ThumbSlideImageWrapper = styled('div')({
  position: 'relative',

  img: {
    width: '100%',
    height: 'auto',
  },
});

const ActiveThumbIconWrapper = styled('div')({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 30%)',
  bottom: '0px',
  zIndex: 1,
  width: '36px',
  height: '36px',
});

const slideImg = (assetId: string, size: number, media = '') => ({
  src: jpgPath(assetId, size, size),
  media: media,
  width: size,
  height: size,
});
